import React from 'react';
import '../css/App.css';

function Footer() {
  return (
    <footer className="footer">
      <p>Feito com <span style={{ 'color': 'red' }}> &hearts; </span> Odisseia</p>
      <p>M A Contabil</p>
    </footer>
  );
}

export default Footer